export default __webpack_public_path__ + "static/media/call-center.e484bdeb.svg";